'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionToSentryFingerprint = undefined;

var _getError = require('./getError');

var actionToSentryFingerprint = exports.actionToSentryFingerprint = function actionToSentryFingerprint(action) {
  var fingerprint = ['{{ default }}', action.type];
  var error = (0, _getError.getError)(action);

  if (error && typeof error.status === 'number') {
    fingerprint.push('' + error.status);
  }

  return fingerprint;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/action/operators/actionToSentryFingerprint.js
// module id = 854
// module chunks = 2 3